import {
  ActivityEnrollableTimesModal_ActivityFragment,
  ClassDetailsNoSectionsQuery,
  ClassDetailsQuery_ActivityFragment
} from "@outschool/gql-frontend-generated";
import React, { SetStateAction, memo } from "react";

import ActivityEnrollableTimes from "../activityEnrollableTimes/ActivityEnrollableTimes";
import AvailableTimes from "../availableTimes/AvailableTimes";
import SelfPacedAvailableNow from "../SelfPacedAvailableNow";
import { TabConfigType } from "../subcomponents/ClassDetailsNav";
import { TabValue } from "../subcomponents/PublicReviewsOfActivity";

export interface BaseClassDetailsMainBodyProps {
  // props
  activity: ClassDetailsQuery_ActivityFragment;
  classNavTabs?: TabConfigType[];
  hasOneOnOneAvailabilities: boolean;
  isAvailabilityModalOpen?: boolean;
  isLoadingOneOnOneAvailabilities: boolean;
  leader: ClassDetailsNoSectionsQuery["activity"]["leader"];
  onClickViewReviews?: () => void;
  setIsAvailabilityModalOpen?: React.Dispatch<SetStateAction<boolean>>;
  setTabValue?: React.Dispatch<React.SetStateAction<TabValue>>;
  showAvailableTimes: boolean;
  tabValue?: TabValue;
  // refs
  sectionsRef: React.RefObject<HTMLElement>;
  // memos & elements
  ActivityEnrollableTimes?: React.JSX.Element | null;
  AvailableTimes?: React.JSX.Element | null;
}

export interface DesktopClassDetailsMainBodyProps
  extends BaseClassDetailsMainBodyProps {
  // props
  activityWithEnrollableTimes?: ActivityEnrollableTimesModal_ActivityFragment;
  isOrganizationEnrollment: boolean;
  onClickMoreLikeThis: () => void;
  onClickViewTeacher?: (event: React.SyntheticEvent) => void;
  // refs
  refsContainer: any;
  viewAvailabilityRef: React.RefObject<HTMLElement>;
}

export interface MobileClassDetailsMainBodyProps
  extends BaseClassDetailsMainBodyProps {
  refsContainer: any;
}

export const ActivityEnrollableTimesMemo = memo(
  function ActivityEnrollableTimesBody({
    activityWithEnrollableTimes,
    leader,
    onEnrollClick
  }: {
    activityWithEnrollableTimes?: ActivityEnrollableTimesModal_ActivityFragment;
    leader: ClassDetailsNoSectionsQuery["activity"]["leader"];
    onEnrollClick: (args: { startTime: Date; orgTeacherUid?: string }) => void;
  }) {
    return !!activityWithEnrollableTimes ? (
      <ActivityEnrollableTimes
        activity={activityWithEnrollableTimes}
        leader={leader}
        onEnrollClick={onEnrollClick}
      />
    ) : (
      <></>
    );
  }
);

export const AvailableTimesMemo = memo(function AvailableTimesBody({
  activity,
  isMounted,
  isOrganizationEnrollment,
  onClickMoreLikeThis
}: {
  activity: ClassDetailsQuery_ActivityFragment;
  isMounted: boolean;
  isOrganizationEnrollment: boolean;
  onClickMoreLikeThis: () => void;
}) {
  if (!isMounted) {
    return null;
  }

  return activity.isSelfPaced ? (
    <SelfPacedAvailableNow activity={activity} />
  ) : (
    <AvailableTimes
      activity={activity}
      isOrganizationEnrollment={isOrganizationEnrollment}
      onClickMoreLikeThis={onClickMoreLikeThis}
    />
  );
});
